import React, { useState } from 'react';
import { useTimerStore } from '../../stores/timerStore';

export function UserBadge() {
  const { user, setUser } = useTimerStore();
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(user?.pseudo || '');

  const handleSave = () => {
    const trimmed = editValue.trim();
    if (trimmed && user) {
      setUser({ ...user, pseudo: trimmed });
    }
    setIsEditing(false);
  };

  if (!user) return null;

  return (
    <div className="flex items-center gap-2">
      {isEditing ? (
        <input
          type="text"
          value={editValue}
          onChange={(e) => setEditValue(e.target.value)}
          onBlur={handleSave}
          onKeyDown={(e) => e.key === 'Enter' && handleSave()}
          className="bg-namm-panel-soft border border-namm-line px-3 py-1 text-xs font-mono text-namm-text outline-none focus:border-namm-cyan w-32"
          autoFocus
          maxLength={20}
        />
      ) : (
        <button
          onClick={() => {
            setEditValue(user.pseudo);
            setIsEditing(true);
          }}
          className="flex items-center gap-2 text-xs font-mono text-namm-text hover:text-namm-cyan transition-colors"
        >
          <div
            className="w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold text-namm-bg"
            style={{ backgroundColor: user.color }}
          >
            {user.pseudo.charAt(0).toUpperCase()}
          </div>
          <span className="hidden sm:inline">{user.pseudo}</span>
        </button>
      )}
    </div>
  );
}
